import * as primerComponents from '@primer/react'
import * as doctocatComponents from '@primer/gatsby-theme-doctocat'

export default {...primerComponents, ...doctocatComponents}
